











import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({
  components: {
  },
})
export default class extends Vue {
  @Prop() titleData!: string;

  private back() {
    // this.$router.push('/vocabulary')
    this.$router.go(-1);
  }
}
